// extracted by mini-css-extract-plugin
export default {"linkButton":"LinkButton_linkButton__sFG-S","black":"LinkButton_black__lGsn4"};